import dayjs from "dayjs";
import type { Duration } from "dayjs/plugin/duration";

import type { Season } from "./season.types";

export const isBeforeSeasonSubmissionsEnd = (
  season: Season,
  /** Optional offset to adjust season end comparison time (for "month past end", etc) */
  offset?: { type: "after" | "before"; value: Duration },
) => {
  let submissionsEnd = dayjs(season.submissionsEnd).endOf("day");
  if (offset?.type === "after") {
    submissionsEnd = submissionsEnd.add(offset.value);
  } else if (offset?.type === "before") {
    submissionsEnd = submissionsEnd.subtract(offset.value);
  }
  return dayjs().isBefore(submissionsEnd);
};

export const isAfterSeasonSubmissionsStart = (season: Season) => {
  const submissionsStart = dayjs(season.submissionsStart).startOf("day");
  return dayjs().isAfter(submissionsStart);
};

export const isSeasonAcceptingSubmissions = (season: Season) => {
  return isBeforeSeasonSubmissionsEnd(season) && isAfterSeasonSubmissionsStart(season);
};
